module.exports = __webpack_public_path__ + "media/newstyle/images/twitter-share-pink-3d693a908631e8c85f9ba8e460988c67.svg";